import { Group, Text, UnstyledButton } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { SUPPORTED_LANGUAGES } from '@/i18n/supportedLanguages';

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const current = i18n.language.split('-')[0];

  return (
    <Group
      gap={2}
      px={2}
      h={26}
      wrap="nowrap"
      style={{ borderRadius: 999, border: '1px solid var(--color-icon-on-secondary-soft)' }}
    >
      {SUPPORTED_LANGUAGES.map((lang) => {
        const active = lang.code === current;
        return (
          <UnstyledButton
            key={lang.code}
            onClick={() => i18n.changeLanguage(lang.code)}
            px={9}
            py={3}
            style={{
              borderRadius: 999,
              display: 'flex',
              alignItems: 'center',
              backgroundColor: active ? 'var(--color-overlay-icon-surface)' : 'transparent'
            }}
          >
            <Text
              fz={11}
              fw={600}
              lh={1}
              style={{
                color: active
                  ? 'var(--color-text-on-secondary)'
                  : 'var(--color-icon-on-secondary-soft)'
              }}
            >
              {lang.label}
            </Text>
          </UnstyledButton>
        );
      })}
    </Group>
  );
};
